import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  userLocations: any;
  constructor(private http: HttpClient, private router: Router) {
    const cachedUser = localStorage.getItem('user') || sessionStorage.getItem('user');
    if (cachedUser) {
      const user = JSON.parse(cachedUser);
      this.accessToken = JSON.parse(localStorage.getItem('token'));
      this.refreshToken = JSON.parse(localStorage.getItem('token'));
      this.userB.next(user);
    }
  }

  private userB = new BehaviorSubject<User>(null);
  public user$ = this.userB.asObservable();

  accessToken: string;
  refreshToken: string;
  userName: any;

  generateOtp(mobileNumber: object) {
    return this.http.post(environment.userApi + `/api/user/public/otp/generate`, mobileNumber);
  }

  verifyOtp(otp: object) {
    return this.http.post(environment.userApi + `/api/user/public/otp/verify`, otp);
  }

  register(userDetails, capcha) {
    return this.http.post(environment.userApi + `/api/user/public/signup?g-recaptcha-response=${capcha}`, userDetails);
  }
  myProfile() {
    return this.http.get(environment.userApi + `/api/user/user`);
  }
  getClaimedUsers() {
    return this.http.get(environment.userApi + `/api/user/admin/users`);
  }
  getHbProjectDetails() {
    return this.http.get(environment.userApi + `/api/user/admin/hbProjectDetails`);
  }
  projectStatusUpdate(custCode, status) {
    return this.http.put(environment.userApi + `/api/user/admin/projectStatus/update/${custCode}/${status}`, {});
  }
  getS3Images(uniqueIdentifier) {
    return this.http.get(environment.userApi + `/api/user/files/${uniqueIdentifier}`, {
      responseType: 'blob',
    });
  }


  passwordRestMail(email) {
    return this.http.post(environment.userApi + `/api/user/public/password/link`, email);
  }

  resetPassword(newPassword, resetToken) {
    return this.http.post(environment.userApi + `/api/user/public/password/reset`, {
      password: newPassword,
      token: resetToken,
    });
  }
  changePassword(password, oldPassword) {
    return this.http.post(environment.userApi + `/api/user/password/changePassword`, {
      password: password,
      oldPassword: oldPassword,
    });
  }
  login(loginDetails) {
    const options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
    };
    return this.http.post<any>(environment.userApi + `/api/user/public/user/login`, loginDetails.toString(), options);
  }

  refreshSession() {
    return new Promise<boolean>((resolve, reject) => {
      const options = {
        headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
      };
      const body = new URLSearchParams();
      if (!this.getRefreshToken()) {
        return resolve(true);
      }
      body.set('refresh_token', this.getRefreshToken());
      body.set('grant_type', 'refresh_token');
      this.http.post<any>(environment.userApi + `/api/user/public/user/login`, body.toString(), options).subscribe(
        (newTokens) => {
          const user = { ...this.getUser(), access_token: newTokens.access_token, refresh_token: newTokens.refresh_token, ...this.getUserRole() };
          this.userName = newTokens?.userName;
          console.log(this.userName);
          this.storeUserInfo(user);
          return resolve(true);
        },
        (err) => {
          this.logout();
          return resolve(true);
        },
      );
    });
  }

  logout() {
    localStorage.clear();
    sessionStorage.clear();
    this.userB.next(null);
    this.accessToken = null;
    this.refreshToken = null;
  }

  getRole() {
    return localStorage.getItem('role') || sessionStorage.getItem('role');
  }

  getAccessToken() {
    return localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
  }

  getRefreshToken() {
    return localStorage.getItem('refresh_token') || sessionStorage.getItem('refresh_token');
  }

  getUser() {
    const cachedUser = localStorage.getItem('user');
    return JSON.parse(cachedUser);
  }

  getLoggedUser() {
    return this.userName;
  }

  getUserRole() {
    const role = sessionStorage.getItem('role') || localStorage.getItem('role');
    return {
      roles: role ? [{ authority: role }] : []
    };
  }

  storeUserInfo(userData, rememberMeChecked?) {
    this.userB.next(userData);
    rememberMeChecked = localStorage.getItem('user') || rememberMeChecked;
    if (userData) {
      if (rememberMeChecked) {
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('access_token', userData.access_token);
        localStorage.setItem('refresh_token', userData.refresh_token);
        localStorage.setItem('user_name', userData?.userName);
        localStorage.setItem('role', userData.roles[0].authority);
      } else {
        sessionStorage.setItem('user', JSON.stringify(userData));
        sessionStorage.setItem('access_token', userData.access_token);
        sessionStorage.setItem('refresh_token', userData.refresh_token);
        sessionStorage.setItem('user_name', userData?.userName);
        sessionStorage.setItem('role', userData.roles[0].authority);
      }
    }
  }
  activateOrDeactivateUser(id, status) {
    return this.http.put(environment.userApi + `/api/user/admin/user/${id}/changeStatus`, { status });
  }

  sendNotification(notificationParams) {
    return this.http.post(environment.userApi + `/api/user/notification/send`, notificationParams);
  }

  sendConcernNotification(concernParams) {
    return this.http.post(environment.userApi + `/api/user/notification/raiseConcern/send`, concernParams);
  }

  getNotificationHistory(page) {
    return this.http.get(environment.userApi + `/api/user/notification/history?pageNo=${page.pageNumber}&pageSize=${page.size}`);
  }
  ledger(custCode, bodyparams, location) {
    return this.http.post(environment.claimsApi + `/api/cpm/ledger/${custCode}/${location}`, bodyparams);
  }

  transferLetter(bodyparams) {
    return this.http.post(environment.claimsApi + `/api/cpm/letter/transferLetter`, bodyparams);
  }

  accountsLedger(custCode, bodyparams, location) {
    return this.http.post(environment.claimsApi + `/api/cpm/ledger/AccountLedger/${custCode}/${location}`, bodyparams);
  }
  posessionDate(custCode, location) {
    return this.http.get(environment.claimsApi + `/api/cpm/ledger/Possession/${custCode}/${location}`, {});
  }
  locationData() {
    return this.http.get(environment.claimsApi + `/api/cpm/ledger/location`);
  }
  getMasterLocations() {
    return this.http.get(environment.claimsApi + `/api/cpm/ledger/master-location`);
  }
  getMasterStatuses() {
    return this.http.get(environment.claimsApi + `/api/cpm/ledger/master-status`);
  }
  getAdvance(custId, location, user): Observable<any> {
    return this.http.post<any>(environment.claimsApi + `/api/payment/payment/advancePaymentSettlement?custCode=${custId}&location=${location}&adminuser=${user}`, {})
  }
  getBillDetails(custId, location) {
    return this.http.post(environment.claimsApi + `/api/cpm/paymentschedule/billdetails/${custId}/${location}`, custId, location);
  }

  invoiceGenerate(custCode, billNos, location) {
    return this.http.post(environment.claimsApi + `/api/cpm/paymentschedule/invoice/${custCode}/${location}`, billNos, { responseType: 'text' })
  }
  getdemandLetter(custId, billNo, location, pendingAmt, interestOnPendingAmt, type, taxOnInterest, taxOnPendingAmt) {
    return this.http.post(environment.claimsApi + `/api/cpm/letter/demandLetter/${custId}/${billNo}/${location}/${type}?pendingAmt=${pendingAmt}&interestOnPendingAmt=${interestOnPendingAmt}&taxOnInterest=${taxOnInterest}&previousInstTax=${taxOnPendingAmt}`, {});
  }
  // getTotalRefund(custId,location){
  //   return this.http.post(environment.claimsApi+`/api/cpm/paymentschedule/viewRefund/${custId}/${location}`,{})
  // }
  getRefund(custId, location) {
    return this.http.post(environment.claimsApi + `/api/cpm/paymentschedule/viewRefund/${custId}/${location}`, {})
  }

  public async downloadResource(id: string): Promise<Blob> {
    const file = await this.http
      .get<Blob>(environment.userApi + '/api/user/file/' + id, { responseType: 'blob' as 'json' })
      .toPromise();
    return file;
  }

  public async downloadFile(id): Promise<string> {
    const blob = await this.downloadResource(id);
    const url = window.URL.createObjectURL(blob);
    return url;
  }
  oldLedger(custCode) {
    return this.http.get(environment.claimsApi + `/api/cpm/ledger/downloadPdf/${custCode}`, { responseType: 'text' });
  }

  raiseConcernLedger(concern: object) {
    return this.http.post(environment.userApi + `/api/user/user/raise/ledgerConcern`, concern);
  }

  fileUpload(file) {
    return this.http.post(environment.userApi + '/api/user/file/upload', file);
  }

  getOutstandingAmtDetails(custId, location) {
    return this.http.post(environment.claimsApi + `/api/cpm/paymentschedule/billoutstandingdetails/${custId}/${location}`, custId, location);
  }
  getTdsDetails(locations) {
    return this.http.post(environment.claimsApi + `/api/cpm/paymentschedule/allTdsDetails`, locations)
  }
  saveTdsPayment(response: object) {
    return this.http.post(environment.claimsApi + `/api/cpm/paymentschedule/saveTdsPayment`, response);
  }
  getTdsReceipts(custCode, location) {
    return this.http.post(environment.claimsApi + `/api/cpm/paymentschedule/tdsReceipt/${custCode}/${location}`, {});
  }
  updateTdsPayment(custCode, location, cheqDate, amount, tdsId, documentId, paymentMode) {
    return this.http.post(environment.claimsApi + `/api/cpm/paymentschedule/tdsPayment/${custCode}/${location}`, { cheqDate, amount, tdsId, documentId, paymentMode });
  }

  getUserLocations(userName) {
    return this.http.post(environment.userApi + `/api/user/public/user/location`, userName);
  }

  getUserName() {
    return this.userName;
  }

  setUserName(username) {
    this.userName = username;
  }
  settleTdsPayments(results) {
    return this.http.post(environment.claimsApi + `/api/cpm/paymentschedule/settleTdsPayments`, results);
  }
  getTdsPayments(locations) {
    return this.http.post(environment.claimsApi + `/api/cpm/paymentschedule/getTdsPaymentsByLocation`, locations)
  }

  updatePropertyTransfer(data: any) {
    return this.http.post(environment.userApi + `/api/user/public/propertyTransfer`, data)
  }

  updatePropertyTransffered(data: any, custCode, location) {
    return this.http.post(environment.userApi + `/api/user/public/propertyTransferred/${custCode}/${location}`, data)
  }

  oldPropertyTransffered(data: any, custCode, location) {
    return this.http.post(environment.userApi + `/api/user/public/propertyTransferred/${custCode}/${location}`, data)
  }

  newPropertyTransffered(data: any) {
   return this.http.post(environment.userApi + `/api/user/public/propertyTransfer`, data)
  }

  getTransferPropertySalesData( custCode, location) {
   return this.http.get(environment.userApi + `/api/user/admin/salesReportByCustomer/${custCode}/${location}`, )
  }

  getProjectNames(location: any) {
    return this.http.get(environment.userApi + `/api/user/lookup/${location}/PROJECT`)
  }

  getDetails(custCode, location) {
    return this.http.get(environment.userApi + `/api/user/admin/customerDetails/${custCode}/${location}`);
  }
  updateDetails(custCode, location, details: any) {
    return this.http.put(environment.userApi + `/api/user/admin/updateCustDetails/${custCode}/${location}`, details);
  }
  getAllDetails(location: string, startDate: string, endDate: string) {
    return this.http.get(environment.userApi + `/api/user/admin/paymentData/${location}?fromDate=${startDate}&toDate=${endDate}`, {})
  }
  getExportFile(location, startDate, endDate) {
    return this.http.get(environment.userApi + `/api/user/admin/tableExcelExport/${location}?fromDate=${startDate}&toDate=${endDate}`, {
      responseType: 'blob',
      params: {
        startDate: startDate,
        endDate: endDate
      }
    });
  }
  getDemandExcel(projectCode, location, startDate, endDate) {
    return this.http.get(environment.userApi + `/api/user/admin/demandExcelExport/${projectCode}/${location}/?startDate=${startDate}&endDate=${endDate}`, {
      responseType: 'blob',
      params: {
        projectCode: projectCode,
        location: location,
        startDate: startDate,
        endDate: endDate,
      }
    });
  }
  getDemandData(projectCode: string, location: string, startDate, endDate): Observable<any> {
    return this.http.get<any>(environment.userApi + `/api/user/admin/demandData/${projectCode}/${location}/?startDate=${startDate}&endDate=${endDate}`);
  }
  getErrorMessage(projectCode, location) {
    return this.http.get<any>(environment.userApi + `/api/user/admin/customerProjectCode/${projectCode}/${location}`);
  }
  getProjectCode(): Observable<string[]> {
    return this.http.get<string[]>(environment.userApi + '/api/user/user/projectCodes');
  }
 

  getDebitDetails(results) {
    return this.http.post(environment.claimsApi + `/api/cpm/paymentschedule/debitDetails`, results);
  }

  getCreditDetails(results) {
    return this.http.post(environment.claimsApi + `/api/cpm/paymentschedule/creditDetails`, results);
  }

  getReceiptDetails(results) {
    return this.http.post(environment.claimsApi + `/api/cpm/paymentschedule/receiptDetails`, results);
  }
  getRecBillDetails(results: any): Observable<any> {
    return this.http.post(environment.claimsApi + `/api/cpm/paymentschedule/recBillDetails`, results);
  }
  // API for Step 1: Interest Receipt
  saveInterestReceipt(data: any) {
    // Replace with your actual backend API URL
    return this.http.post(environment.claimsApi + `/api/cpm/paymentschedule/savereceiptDetails`, data);
  }
  saveInterestTax(data: any) {
    // Replace with your actual backend API URL
    return this.http.post(environment.claimsApi + `/api/cpm/paymentschedule/saveInterestTax`, data);
  }

  // API for Step 2: Interest RecBill
  saveInterestRecBill(data: any) {
    // Replace with your actual backend API URL
    return this.http.post(environment.claimsApi + `/api/cpm/paymentschedule/saveInterestRecBill`, data);
  }
  getTaxDetails(results: any): Observable<any> {
    return this.http.post(environment.claimsApi + `/api/cpm/paymentschedule/taxDetails`, results);
  }
  getSalesExcel(projectCode, location) {
    return this.http.get(environment.userApi + `/api/user/admin/salesExcelReport/${projectCode}/${location}`, {
      responseType: 'blob',
      params: {
        projectCode: projectCode,
        location: location,
      }
    });
  }
  getSalesData(projectCode: string, location: string): Observable<any> {
    return this.http.get<any>(environment.userApi + `/api/user/admin/salesReport/${projectCode}/${location}`);
  }
  getPaymentExcel(projectCode, location, fromDate, toDate) {
    return this.http.get(environment.userApi + `/api/user/admin/dailyExcelReport/${projectCode}/${location}/?fromDate=${fromDate}&toDate=${toDate}`, {
      responseType: 'blob',
      params: {
        projectCode: projectCode,
        location: location,
        fromDate: fromDate,
        toDate: toDate,
      }
    });
  }
  getPaymentData(projectCode: string, location: string, fromDate, toDate): Observable<any> {
    return this.http.get<any>(environment.userApi + `/api/user/admin/dailyReport/${projectCode}/${location}/?fromDate=${fromDate}&toDate=${toDate}`);
  }
  //showing ifms and misc in admin portal (21-05-2025)
  getIfmsData(custId: string, location: string): Observable<any> {
    return this.http.get<any>(environment.claimsApi + `/api/cpm/paymentschedule/getIfmsData/${custId}/${location}`, {});
  }

  getMiscData(custId: string, location: string): Observable<any> {
    return this.http.get<any>(environment.claimsApi + `/api/cpm/paymentschedule/getMiscData/${custId}/${location}`, {});
  }
  possession(custCode, location) {
    return this.http.post(environment.claimsApi + `/api/cpm/letter/possessionLetter/${custCode}/${location}`, {});
  }
  updateContractorDetails(body) {
    return this.http.put(environment.claimsApi + `/api/cpm/paymentschedule/updateContractorDetails`, body);
  }
  //get api for parking details
  getParkingDetails(custId: string, location: string): Observable<any> {
    return this.http.get<any>(environment.claimsApi + `/api/cpm/paymentschedule/getParkingDetails/${custId}/${location}`, {});
  }
  //update parking details
  updateParkingDetails(body) {
    return this.http.put(environment.claimsApi + `/api/cpm/paymentschedule/updateParkingDetails`, body);

  }
  getTrasferPropertyExcel(location: string, prjNames: string, startDate?: string | null, endDate?: string | null) {
    const params: any = {};

    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    return this.http.get(
      `${environment.userApi}/api/user/admin/transferReportExcel/${location}/${prjNames}`,
      {
        responseType: 'blob',
        params
      }
    );
  }


  getTransferPropertyData(location: string, prjNames: string, startDate?: string | null, endDate?: string | null): Observable<any> {
    const params: any = {};

    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    return this.http.get<any>(environment.userApi + `/api/user/admin/transferReportData/${location}/${prjNames}`, { params });
  }

  getProjectName(location: any) {
    return this.http.get(environment.userApi + `/api/user/lookup/projectDetail/${location}`)
  }

  getProjectCodesByLocation(location: string) {
    return this.http.get<string[]>(environment.userApi + `/api/user/user/projectCodeLocation/${location}`);
  }

  getTdsData(location: string, status: string, fromDate?: string | null, toDate?: string | null): Observable<any> {
    const params: any = {};

    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;

    return this.http.get<any>(environment.userApi + `/api/user/admin/tdsReportData/${location}/${status}`, { params });
  }

  getTdsExcel(location, status, fromDate?: string | null, toDate?: string | null) {
    const params: any = {
      location: location,
      status: status,
    };

    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;

    return this.http.get(environment.userApi + `/api/user/admin/tdsReportExcel/${location}/${status}`, {
      responseType: 'blob',
      params
    });
  }
   getProjectandnameByLoaction(location: string) {
    return this.http.get<string[]>(environment.userApi + `/api/user/user/projectNameCode/${location}`);
  }
  getProjectCodeandName(): Observable<string[]> {
    return this.http.get<string[]>(environment.userApi + '/api/user/user/projectNameandCodes');
  }

  // get customer details data
  getCustomerDetails(custCode: string, location: string) {
    return this.http.get(environment.userApi + `/api/user/user/CustomerDetails?custCode=${custCode}&location=${location}`);
  }

  // update first allottee
  updateFirstAllottee(custCode: string, location: string, data: any) {
    return this.http.put(
      environment.userApi + '/api/user/user/updatefirstalotte',
      data,
      { responseType: 'text' }
    );
  }

  // update joint holder
  updateJointHolder(custCode: string, location: string, data: any) {
    return this.http.put(
      environment.userApi + '/api/user/user/update-joint-holder',
      data,
      { responseType: 'text' }
    );
  }

  // delete allottees
  deleteFirstAllottee(custCode: string, location: string) {
    return this.http.put(
      environment.userApi + `/api/user/user/delete-ownership?custCode=${custCode}&location=${location}`,
      {},
      { responseType: 'text' }
    );
  }

  // Generate  letter
  generatefirstAloteeAdditionLetter(custCode: string, location: string) {
    return this.http.post(environment.claimsApi + `/api/cpm/letter/generate-addition-letter?custCode=${custCode}&location=${location}`,{});
  }

  // Generate  delete letter
  generatefirstAloteeDeletionLetter(custCode: string, location: string) {
    return this.http.post(environment.claimsApi + `/api/cpm/letter/generate-deletion-letter?custCode=${custCode}&location=${location}`,{});
  }
  generateJointAllotteeadditinLetter(custCode: string, location: string) {
    return this.http.post(environment.claimsApi + `/api/cpm/letter/generate-jtaddition-letter?custCode=${custCode}&location=${location}`,{});
  }
  // Generate  JointAllottee letter
  generateJointAllotteeDeleletionLetter(custCode: string, location: string) {
    return this.http.post(environment.claimsApi + `/api/cpm/letter/jointAllottee-Deletion-Letter?custCode=${custCode}&location=${location}`,{});
  }
}
